module.exports = __webpack_public_path__ + "img/593.b9a37da6.jpg";